import type { PlgPermissionService } from '@/domains/shared/services/base-plg-permission-service';

/**
 * DesignFTO模块编辑权限服务
 *
 * 用于判断当前用户是否有权限编辑DesignFTO模块内容
 */
export interface DesignFtoPermissionService extends PlgPermissionService {}

export const DesignFtoPermissionService = Symbol.for('DesignFtoPermissionService');
